import { gql } from "@apollo/client"

export const SNAPCOURSE_QUERY = `
snapCourseContentId
type
name
description
ownerId
meta {
  ... on MasteryLessonSnapCourseMeta {
      snapDocId
      lessonId
      publishStatus
      publishDate
      canDelete
      canUnpublish
      totalSeconds
      interactionCount
      questionCount
      isAssignedInAGroup
      isAssignedToCurrentGroup
  }
  ... on PracticeTestSnapCourseMeta {
      snapDocId
      publishStatus
      publishDate
      canDelete
      canUnpublish
  }
  ... on ElementSnapCourseMeta {
      snapDocId
      publishStatus
      publishDate
  }
  ... on StandAloneSnapCourseMeta {
      snapDocId
      publishStatus
      publishDate
  }
}`

export const GET_SNAPCOURSES_BYPROGRAMCOURSE = gql`
    query content_getSnapCoursesByProgramCourse(
      $data: ProgramCourseInput!,
    ){content_getSnapCoursesByProgramCourse(data: $data){
        ${SNAPCOURSE_QUERY}
    }
    }
`
export const GET_SNAPCOURSE_BYID = gql`
    query content_getSnapCourseById(
      $data: SnapCourseIdInput!,
    ){content_getSnapCourseById(data: $data){
        ${SNAPCOURSE_QUERY}
    }
    }
`

export const GET_STANDARDS_BY_PROGRAM_COURSE = gql`
  query content_getStandardsByProgramCourse($data: ProgramCourseInput!) {
    content_getStandardsByProgramCourse(data: $data) {
      standards
    }
  }
`

const SnapCourseSearchResult = `
      snapCourses{
        ${SNAPCOURSE_QUERY}
      }
      meta{
        hasNext
        hasPrevious
        page
        pageSize
      }
`

export const FIND_MASTERYLESSON_SNAPCOURSES_BY_DRAFT_CONTENT_ID = gql`
  query content_findMasteryLessonSnapCoursesByDraftContentId(
    $data: SnapCoursesFindByDraftContentIdInput!
  ) {
    content_findMasteryLessonSnapCoursesByDraftContentId(data: $data) {
      ${SnapCourseSearchResult}
    }
  }
`

export const FIND_MASTERYLESSON_SNAPCOURSES_BY_PROGRAM_COURSE = gql`
  query content_findMasteryLessonSnapCoursesByProgramCourse(
    $data: SnapCoursesFindByProgramCoursesInput!
  ) {
    content_findMasteryLessonSnapCoursesByProgramCourse(data: $data) {
      ${SnapCourseSearchResult}
    }
  }
`

export const GET_CONTENT_AUTHORS_FOR_PROGRAM_COURSE = gql`
  query content_getContentAuthorsForProgramCourse($data: ProgramCourseInput!) {
    content_getContentAuthorsForProgramCourse(data: $data) {
      id
      name
    }
  }
`

export const GET_SNAPCOURSE_BY_REF_ID_AND_TYPE = gql`
  query content_getSnapCourseByRefIdAndType($data: SnapCourseRefIdInput!) {
    content_getSnapCourseByRefIdAndType(data: $data) {
      snapCourseContentId
      type
      name
      description
      ownerId
      meta {
        ... on MasteryLessonSnapCourseMeta {
          snapDocId
          programCourses {
            program
            course
            standards
            standardIds
            knowledgeNodeIds
            reportingCategoryIds
            canUntagCourse
          }
          canDelete
          canUnpublish
          publishStatus
          publishDate
          totalSeconds
          interactionCount
          questionCount
          isAssignedInAGroup
          isAssignedToCurrentGroup
        }
        ... on PracticeTestSnapCourseMeta {
          publishStatus
          publishDate
          canDelete
          canUnpublish
          programCourses {
            program
            course
            standards
            standardIds
            knowledgeNodeIds
            reportingCategoryIds
            canUntagCourse
          }
        }
        ... on ElementSnapCourseMeta {
          publishStatus
          publishDate
          programCourses {
            program
            course
            standards
            standardIds
            knowledgeNodeIds
            reportingCategoryIds
            canUntagCourse
          }
        }
        ... on StandAloneSnapCourseMeta {
          publishStatus
          publishDate
          programCourses {
            program
            course
            standards
            standardIds
            knowledgeNodeIds
            reportingCategoryIds
            canUntagCourse
          }
        }
      }
    }
  }
`
